import {
    CollectionPersistenceModel,
    CollectionPersistenceDto,
} from '../../data-layer/collections/types';

export const toCollectionPersistenceDto = (
    model: CollectionPersistenceModel,
): CollectionPersistenceDto => ({
    display_name: model.displayName,
    is_public: model.isPublic,
    show_in_feed: model.feedStatus?.showInFeed,
});
